import React, { useEffect, useState } from "react";
import classes from "./ChallengeCountdown.module.css";
import CommonButton from "../../../ui/CommonButton";
import useWindowDimensions from "../../../hooks/getWindowDimensions";
import { env } from "../../../constants/env";
import axios from "axios";
import { useUser } from "../../../context/UserContext";

const ChallengeCountdown = ({ setShowPurchase }) => {
  const [loading, setLoading] = useState(false);

  const calculateTimeLeft = () => {
    const targetDate = new Date("2026-09-17T21:00:00Z"); // 2PM PST = 21:00 UTC
    const now = new Date();
    const difference = targetDate - now;

    if (difference <= 0) {
      return { days: 0, hours: 0, minutes: 0, totalMs: 0 };
    }

    const days = Math.floor(difference / (1000 * 60 * 60 * 24));
    const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((difference / (1000 * 60)) % 60);

    return { days, hours, minutes, totalMs: difference };
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());
  const [slotData, setSlotData] = useState(null);

  const initialFormState = {
    email: "",
    password: "",
    username: "",
  };
  const [formData, setFormData] = useState(initialFormState);
  const [showSignUp, setShowSignUp] = useState(false);
  const [mode, setMode] = useState(null);
  const [error, setError] = useState("");
  const [isSending, setIsSending] = useState(false);

  const { width } = useWindowDimensions();

  const isMobile = width <= 768; // Mobile breakpoint

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000 * 60); // update every minute

    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    const fetchSlotData = async () => {
      try {
        const response = await axios.get(`${env.apiUrl}/api/user/slots`);
        setSlotData(response.data);
      } catch (err) {
        console.error("Failed to fetch slot data:", err);
      }
    };

    fetchSlotData();
  }, []);

  return (
    <div className={`${classes.wrapper}`}>
      <div
        className={`row mx-0 flex-column flex-md-row align-items-center justify-content-between gap-4 ${classes.contentBox}`}
      >
        {/* Left Section */}
        <div className="col-12 col-md-6 text-center text-md-start">
          {slotData?.availableSlots > 0 && timeLeft?.totalMs > 0 ? (
            <>
              <h3 className="text-white mb-3">
                Next Challenge Starts 17th September, 2pm PST
              </h3>

              {!isMobile && (
                <CommonButton
                  text="Secure a spot"
                  onClick={() => {
                    window.location.href = "/trading?secure_spot=true";
                  }}
                />
              )}
            </>
          ) : (
            <>
              <h3 className="text-white mb-3">
                All Spots Filled for September's Cohort
              </h3>
              {!isMobile && (
                <a href="https://discord.com/invite/8z37khrMA6" target="_blank">
                  Join our discord to be first to know when new spots open
                </a>
              )}
            </>
          )}
        </div>

        {/* Middle Countdown */}
        <div
          className={`col-12 col-md-4 d-flex justify-content-center ${classes.outerTimerBox}`}
        >
          <div className="d-flex justify-content-center gap-3">
            <div
              className={`${classes.timerWrapper} d-flex flex-column justify-content-center gap-2`}
            >
              <div className={classes.timerBox}>
                <span className={classes.timerValue}>{timeLeft.days}</span>
              </div>
              <span className={classes.timerLabel}>DAYS</span>
            </div>

            <div
              className={`${classes.timerWrapper} d-flex flex-column justify-content-center gap-2`}
            >
              <div className={classes.timerBox}>
                <span className={classes.timerValue}>{timeLeft.hours}</span>
              </div>
              <span className={classes.timerLabel}>HOURS</span>
            </div>

            <div
              className={`${classes.timerWrapper} d-flex flex-column justify-content-center gap-2`}
            >
              <div className={classes.timerBox}>
                <span className={classes.timerValue}>{timeLeft.minutes}</span>
              </div>
              <span className={classes.timerLabel}>MINUTES</span>
            </div>
          </div>
        </div>

        {isMobile && slotData?.availableSlots > 0 && timeLeft?.totalMs > 0 && (
          <CommonButton
            text="Secure a spot"
            onClick={() => {
              window.location.href = "/trading?secure_spot=true";
            }}
          />
        )}
      </div>
    </div>
  );
};

export default ChallengeCountdown;
